




























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import store from "@/store";

@Component({ components: { CPageButtons, CBlock, CBreadCrumbs, CustomButton } })
export default class CPage extends Vue {
  @Prop({ default: false }) disable!: boolean;
  @Prop() header?: string;
  @Prop() headerIcon?: "add" | "edit" | "back" | "lock" | null;
  @Prop({
    default: () => {
      return {};
    }
  })
  headerIconTo?: any;
  @Prop({ default: true }) isShowIcon?: boolean;
  @Prop() isFilterable?: boolean;
  @Prop() breadCrumbs?: Array<any>;
  @Prop({ default: true }) isAllowToHideFilter?: boolean;
  @Prop({ default: null }) bottomButtonsType?: "add" | "edit" | null;
  @Prop({ default: false }) isShowSpinner?: boolean;
  @Prop({ default: false }) isShowLockIcon?: boolean;

  get headerIconType() {
    if (this.headerIcon == "add") return "fa fa-plus";
    if (this.headerIcon == "edit") return "fas fa-pencil-alt";
    if (this.headerIcon == "back") return "fa fa-chevron-left";
    return null;
  }

  @Watch("header", { immediate: true })
  checkHeader() {
    if (this.header) {
      document.title =
        `${this.header} | ${this.companyTitle ?? ""}` ??
        this.$route.meta?.title;
    }
  }

  @Watch("companyTitle", { immediate: true })
  checkCompanyTitle() {
    if (this.companyTitle) {
      document.title =
        `${this.header} | ${this.companyTitle ?? ""}` ??
        this.$route.meta?.title;
    }
  }

  get companyTitle() {
    return store.getters?.selectedCompany?.title;
  }

  clearFilter() {
    this.$emit("clearFilter");
  }

  applyFilter() {
    this.$emit("applyFilter");
  }
}
